import Case from './case.js';
export default ({
    state: {
        krpano: null,
        sceneList: [],
        oldSceneList: [],
        hotList: [],
        currentSceneIndex: 0, // 当前场景索引
        currentHotsList: [],
        handleHotState: {},
        hotChange: '',
        handleHotOut: false, // 离开热点
        handleHotHover: false // 鼠标悬浮热点
    },
    mutations: {
        setSceneList (state, list) {
            state.sceneList = list;
        },
        setOldSceneList (state, list) {
            state.oldSceneList = list;
        },
        setIndex (state, index) {
            state.currentSceneIndex = index
        },
        setInitView (state) {
            //初始化视角参数
            state.krpano.get('autorotate').interrupt();
            let waittime = state.krpano.get('autorotate.waittime');
            let enabled = state.krpano.get('autorotate.enabled');
            let fovmin = state.krpano.get('view.fovmin');
            let fovmax = state.krpano.get('view.fovmax');
            let fov = state.krpano.get('view.fov');
            let vlookat = state.krpano.get('view.vlookat');
            let hlookat = state.krpano.get('view.hlookat');
            // 记录初始视角和缩放范围
            if (!state.sceneList[state.currentSceneIndex]) return false;

            state.sceneList[state.currentSceneIndex].autorotate = {
                enabled: enabled,
                waittime: waittime
            };
            state.sceneList[state.currentSceneIndex].view = {
                fovmin: fovmin,
                fov: fov,
                fovmax: fovmax,
                hlookat: hlookat,
                vlookat: vlookat
            };

            let brightness = state.krpano.get('beauty.brightness') || 0;
            let contrast = state.krpano.get('beauty.contrast') || 0;
            let saturation = state.krpano.get('beauty.saturation') || 0;
            let hue = state.krpano.get('beauty.hue') || 0;
            let btype = state.krpano.get('beauty.btype') || 0;

            // 美化
            state.sceneList[state.currentSceneIndex].beauty = {
                brightness: brightness,
                contrast: contrast,
                saturation: saturation,
                hue: hue,
                btype: btype
            };

            // 初始化热点
            if (!state.sceneList[state.currentSceneIndex].hotSpots) {
                state.sceneList[state.currentSceneIndex].hotSpots = [];
                state.krpano.get('hotspot').getArray().map(item => {
                    if (item.name != 'undefined' && item.name != 'webvr_prev_scene' && item.name != 'webvr_next_scene' && item.name != 'vr_cursor' && item.name != 'loadinganimation') {
                        item.text = item.text 
                            ? item.text.replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&apos;/g,"'").replace(/&quot;/g,'"')
                            : item.text
                        item.detail = item.detail
                            ? item.detail.replace(/&amp;/g,"&").replace(/&lt;/g,"<").replace(/&gt;/g,">").replace(/&apos;/g,"'").replace(/&quot;/g,'"')
                            : item.detail
                        state.sceneList[state.currentSceneIndex].hotSpots.push(item);
                    }
                });
            }

            // 热点移动
            state.hotList = state.sceneList[state.currentSceneIndex].hotSpots;
            state.hotList.map(hotspot => {
                state.krpano.call("set(hotspot[" + hotspot.name + "].ondown,draghotspot(););")
                hotspot.onup = function () {
                    Case.state.saveFlag = true;
                };
                hotspot.onclick = function () {
                    state.hotChange = new Date().getTime();
                    state.handleHotState = hotspot;
                }
                hotspot.onhover = function () {
                    state.handleHotHover = true;
                    state.handleHotState = hotspot;
                }
                hotspot.onout = function () {
                    state.handleHotHover = false;
                }
            });

            state.currentHotsList = state.sceneList[state.currentSceneIndex] ? state.sceneList[state.currentSceneIndex].hotSpots : [];
        }
    },
    getters: {
        krpano: state => state.krpano,
        sceneList: state => state.sceneList,
        oldSceneList: state => state.oldSceneList,
        currentSceneIndex: state => state.currentSceneIndex,
        hotList: state => state.hotList,
        currentHotsList: state => state.currentHotsList,
        handleHotState: state => state.handleHotState,
        hotChange: state => state.hotChange,
        handleHotHover: state => state.handleHotHover
    },
    actions: {
        handleSceneList ({ commit }, list) {
            commit('setSceneList', list);
        },
        handleOldSceneList ({ commit }, list) {
            commit('setOldSceneList', list);
        },
        handleView ({ commit }) {
            commit('setInitView');
        },
        setCurrentSceneIndex ( { commit }, index) {
            commit('setIndex', index);
        }
    }
});


// WEBPACK FOOTER //
// ./src/store/module/krpano.js